import type { RouteRecordRaw } from 'vue-router'

export const defaultLayout = () => import('@/layout/index.vue')

export const notFound: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import('@/views/not-found/index.vue'),
}

export const svgView: RouteRecordRaw = {
  path: '/svg-view',
  name: 'SvgView',
  component: () => import('@/views/common/svg-view.vue'),
}
